import React from 'react';
import { Container, Row, Col, Button, Card, Carousel } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalculator, faPiggyBank, faMagic, faCheckCircle, faDownload, faChartSimple } from '@fortawesome/free-solid-svg-icons';
import { faApple } from '@fortawesome/free-brands-svg-icons';

function Home() {
  const ImageRotator = () => (
    <Carousel nextIcon={<span aria-hidden="true" className="carousel-control-next-icon bg-dark p-2 rounded-circle" />} prevIcon={<span aria-hidden="true" className="carousel-control-prev-icon bg-dark p-2 rounded-circle" />} interval={null}>
      {['./images/image1.png', './images/image2.png', './images/image3.png', './images/image4.png', './images/image5.png'].map((src, index) => (
        <Carousel.Item key={src}>
          <img
            className="d-block mx-auto shadow-sm rounded"
            src={src}
            alt={`Slide ${index + 1}`}
            style={{ maxHeight: '400px', maxWidth: '100%', objectFit: 'contain' }}
          />
        </Carousel.Item>
      ))}
    </Carousel>
  );

  return (
    <>
      {/* Hero Section */}
      <Row className="justify-content-center text-center py-5 bg-light mb-5 shadow-sm">
        <Col md={10} lg={8}>
          <h1 className="display-4 fw-bold mb-3" style={{ color: 'var(--accent-primary)' }}>Ladda smartare och spara pengar.</h1>
          <p className="lead mb-4">Laddvis optimerar din elbilsladdning efter dygnets lägsta priser – helt automatiskt.</p>
          <div className="d-grid gap-3 d-sm-flex justify-content-sm-center">
            <a href="https://play.google.com/store/apps/details?id=se.laddvis" target="_blank" rel="noopener noreferrer" className="btn btn-primary btn-lg px-4">
              <FontAwesomeIcon icon={faDownload} className="me-2" />
              Google Play
            </a>
            <a href="https://apps.apple.com/" target="_blank" rel="noopener noreferrer" className="btn btn-outline-primary btn-lg px-4">
              <FontAwesomeIcon icon={faApple} className="me-2" />
              App Store
            </a>
          </div>
        </Col>
      </Row>

      {/* Features Section (Cards) */}
      <Container className="mb-5">
        <Row className="g-4 justify-content-center">
          {/* Card 1: Savings */}
          <Col md={6} lg={4}>
            <Card className="h-100 shadow-sm text-center">
              <Card.Body>
                <FontAwesomeIcon icon={faPiggyBank} size="3x" className="mb-3 text-primary" />
                <Card.Title as="h3">Maximera besparingar</Card.Title>
                <Card.Text>
                  Ladda din bil när elpriset är som lägst. Laddvis analyserar priserna och schemalägger laddningen automatiskt för att sänka dina kostnader. 
                  Om ditt elnätsbolag har gått över på effekttaxa så löser Laddvis även det!
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>

          {/* Card 2: Simple & Automatic */}
          <Col md={6} lg={4}>
            <Card className="h-100 shadow-sm text-center">
              <Card.Body>
                <FontAwesomeIcon icon={faMagic} size="3x" className="mb-3 text-primary" />
                <Card.Title as="h3">Enkelt & Automatiskt</Card.Title>
                <Card.Text>
                  Ställ in dina preferenser en gång, sedan sköter Laddvis resten. Anslut bara bilen så startar laddningen vid optimal tidpunkt.
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>

          {/* Card 3: Compatibility */}
          <Col md={6} lg={4}>
            <Card className="h-100 shadow-sm text-center">
              <Card.Body>
                <FontAwesomeIcon icon={faCheckCircle} size="3x" className="mb-3 text-primary" />
                <Card.Title as="h3">Kompatibilitet</Card.Title>
                <Card.Text>
                  Laddvis fungerar just nu med Easee-laddboxar men fler är på gång. Appen finns givetvis för både Android och iOS!
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>

          {/* Card 4: Effekttariff */}
          <Col md={6} lg={4}>
            <Card className="h-100 shadow-sm text-center">
              <Card.Body>
                <FontAwesomeIcon icon={faChartSimple} size="3x" className="mb-3 text-primary" />
                <Card.Title as="h3">Effekttaxa</Card.Title>
                <Card.Text>
                  Om ditt elnätsbolag har gått över på effekttaxa/effekttariff så kan du enkelt beskriva tiderna för
                  höglast och sen ser Laddvis till att inte ladda bilen under de timmarna!
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
      
      {/* Savings Calculator Section - Placed after Features */}
      <Container className="mb-5">
        <Row className="justify-content-center">
            <Col md={10} lg={8} className="content-section text-center shadow-sm">
                <h3>Räkna på hur mycket du kan spara</h3>
                <p>Använd vår kalkylator för att se din potentiella besparing baserat på din bil och dina laddvanor.</p>
                <Link to="/savings-simulator">
                <Button variant="primary" size="lg">
                    <FontAwesomeIcon icon={faCalculator} className="me-2" />
                    Räkna på besparingar
                </Button>
                </Link>
            </Col>
        </Row>
      </Container>

      {/* App Screenshots Section - Commented out */}
      {/* 
      <Container className="mb-5">
          <Row className="justify-content-center">
              <Col md={10} lg={8} className="text-center">
                  <h2 className="mb-4">Så här ser det ut</h2>
                  <ImageRotator />
              </Col>
          </Row>
      </Container>
      */}
    </>
  );
}

export default Home;

